function containHtml(defaultValue) {
    return defaultValue.indexOf("<") > -1 && defaultValue.indexOf(">") > -1;
}
function containVariable(defaultValue) {
    return defaultValue.indexOf("[[") > -1 && defaultValue.indexOf("]]") > -1;
}
export function convertToZzZz(text) {
    let longerText = text;
    longerText = longerText.replace(/a/g, "ªªª");
    longerText = longerText.replace(/A/g, "Å");
    longerText = longerText.replace(/B/g, "ß");
    longerText = longerText.replace(/c/g, "¢");
    longerText = longerText.replace(/C/g, "Ç");
    longerText = longerText.replace(/D/g, "Ð");
    longerText = longerText.replace(/e/g, "ëëë");
    longerText = longerText.replace(/i/g, "ïïï");
    longerText = longerText.replace(/I/g, "1");
    longerText = longerText.replace(/L/g, "£");
    longerText = longerText.replace(/n/g, "ñññ");
    longerText = longerText.replace(/N/g, "Ñ");
    longerText = longerText.replace(/O/g, "ÕÕÕ");
    longerText = longerText.replace(/o/g, "øøø");
    longerText = longerText.replace(/p/g, "Þ");
    longerText = longerText.replace(/R/g, "®");
    longerText = longerText.replace(/S/g, "§");
    longerText = longerText.replace(/u/g, "üüü");
    longerText = longerText.replace(/U/g, "Ü");
    longerText = longerText.replace(/y/g, "ÿÿÿ");
    return longerText;
}
function pseudoization(normalString, generateString) {
    let defaultValue = normalString;
    let pseudoString = "";
    if (containVariable(defaultValue)) {
        while (containVariable(defaultValue)) {
            const start = defaultValue.indexOf("[[");
            const end = defaultValue.indexOf("]]");
            pseudoString += start > 0 ? generateString(defaultValue.substring(0, start)) : "";
            pseudoString += defaultValue.substring(start, end + 2);
            defaultValue = defaultValue.replace(defaultValue.substring(0, end + 2), "");
        }
    }
    else if (containHtml(defaultValue)) {
        pseudoString = defaultValue;
    }
    else {
        pseudoString = generateString(defaultValue);
    }
    return pseudoString;
}
export function pseudoizeResource(resource, generateString) {
    return Object.keys(resource).reduce((acc, key) => {
        const pseudoMessage = pseudoization(resource[key], generateString);
        return Object.assign(Object.assign({}, acc), { [key]: pseudoMessage });
    }, {});
}
//# sourceMappingURL=pseudoization.js.map